module.exports = __webpack_public_path__ + "img/inter14.8cf42dd3.jpg";